import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React, { useMemo } from 'react';
import { cn } from '@/lib/utils';
import { useVideos } from './hooks/useVideos';
import { VideoFolderPicker } from '@/components/shared/VideoFolderPicker';

interface VideoSelectorForMetricsProps {
  value: string;
  onChange: (videoId: string | null, videoMP4?: string | null) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function VideoSelectorForMetrics({
  value,
  onChange,
  placeholder = translateInterfaceText("Selecionar Vídeo"),
  disabled = false,
  className,
}: VideoSelectorForMetricsProps) {
  useLanguage();
  const { videos, isLoading } = useVideos();

  const pickerVideos = useMemo(
    () => videos.map((v) => ({ id: v.id_video, title: v.nomeVideo, thumbnailUrl: v.frame })),
    [videos]
  );

  // Resolve o videoMP4 a partir do id selecionado para manter a assinatura
  // onChange(videoId, videoMP4) consumida pelo EnhancedMetricsHeader.
  const handleChange = (videoId: string) => {
    const selected = videos.find((v) => v.id_video === videoId);
    onChange(videoId, (selected as any)?.videoMP4 ?? null);
  };

  return (
    <VideoFolderPicker
      value={value}
      videos={pickerVideos}
      onChange={handleChange}
      placeholder={isLoading ? translateInterfaceText("Carregando vídeos...") : placeholder}
      disabled={disabled || isLoading}
      triggerClassName={cn(
        "flex h-10 w-full items-center justify-between gap-2 rounded-md border border-input bg-background px-3 text-sm text-[#6b7280] hover:border-[#4B7BFF] transition-colors disabled:opacity-50",
        className
      )}
    />
  );
}
